module.exports = __webpack_public_path__ + "img/014.6aa7aa07.jpg";